import { dispatchAlerts, onErroredResponse } from "./responseConverters";
import { ApiResult } from "../models/ApiResult";
import { t } from "i18next";

export const UNKNOWN_ERROR = "wystapil_nieznany_blad";

export default async function tryCatchRequest(
  throwableFunction: Function,
  onSuccess: Function,
  dispatch: Function,
  onFinish: Function = () => {},
  onError: Function = () => {}
) {
  let response: ApiResult = {} as ApiResult;
  let isAborted = false;
  try {
    response = await throwableFunction();
    if (response.isError) {
      dispatch(onErroredResponse(response.errorTable));
      onError();
    } else {
      onSuccess(response.result);
      const alerts = dispatchAlerts(response);
      alerts && dispatch(alerts);
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      console.log(error);
      dispatch(onErroredResponse([t(UNKNOWN_ERROR)]));
      onError();
    } else {
      isAborted = true;
    }
  } finally {
    !isAborted && onFinish();
  }
  return !response.isError;
};
